var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Card, DatePicker, Drawer, Form, Input, Modal, Select, Space, Table, Tag, Typography, message } from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { deleteAdminDatePost, fetchAdminDatePost, fetchAdminDatePosts, pauseAdminDatePost, resumeAdminDatePost } from '../cores/api/api-date-posts';
import { DATE_POST_QUERY_KEY, DATE_POST_STATUS_COLOR_MAP, DATE_POST_STATUS_FILTER_OPTIONS, DATE_POST_STATUS_LABEL_MAP } from '../contants/option';
dayjs.extend(utc);
dayjs.extend(timezone);
const JAPAN_TIMEZONE = 'Asia/Tokyo';
const Link = Typography.Link, Text = Typography.Text;
const RangePicker = DatePicker.RangePicker;
const formatDatetime = (value, fallback = '-') => {
    if (!value)
        return fallback;
    return dayjs(value).tz(JAPAN_TIMEZONE).format('YYYY/MM/DD HH:mm');
};
const truncateText = (value, length = 40) => {
    const text = (value || '').trim();
    if (!text)
        return '-';
    return text.length > length ? `${text.slice(0, length)}…` : text;
};
const readInitialPostId = () => {
    const el = document.getElementById('react-date-posts-page');
    const raw = el === null || el === void 0 ? void 0 : el.getAttribute('data-initial-id');
    if (!raw || !/^\d+$/.test(raw))
        return null;
    return Number(raw);
};
export default function DatePostsPage({ embedded = false }) {
    var _a, _b, _c, _d;
    const _Form$useForm = Form.useForm(), _Form$useForm2 = _slicedToArray(_Form$useForm, 1), filterForm = _Form$useForm2[0];
    const _message$useMessage = message.useMessage(), _message$useMessage2 = _slicedToArray(_message$useMessage, 2), messageApi = _message$useMessage2[0], contextHolder = _message$useMessage2[1];
    const queryClient = useQueryClient();
    const _useState = useState('all'), _useState2 = _slicedToArray(_useState, 2), statusFilter = _useState2[0], setStatusFilter = _useState2[1];
    const _useState3 = useState(''), _useState4 = _slicedToArray(_useState3, 2), femaleFilter = _useState4[0], setFemaleFilter = _useState4[1];
    const _useState5 = useState(), _useState6 = _slicedToArray(_useState5, 2), createdFrom = _useState6[0], setCreatedFrom = _useState6[1];
    const _useState7 = useState(), _useState8 = _slicedToArray(_useState7, 2), createdTo = _useState8[0], setCreatedTo = _useState8[1];
    const _useState9 = useState(1), _useState0 = _slicedToArray(_useState9, 2), page = _useState0[0], setPage = _useState0[1];
    const _useState1 = useState(20), _useState10 = _slicedToArray(_useState1, 2), perPage = _useState10[0], setPerPage = _useState10[1];
    const _useState11 = useState(false), _useState12 = _slicedToArray(_useState11, 2), detailOpen = _useState12[0], setDetailOpen = _useState12[1];
    const _useState13 = useState(null), _useState14 = _slicedToArray(_useState13, 2), selectedId = _useState14[0], setSelectedId = _useState14[1];
    const initialPostId = useMemo(() => readInitialPostId(), []);
    const apiFilters = useMemo(() => _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        page,
        per_page: perPage
    }, statusFilter !== 'all' ? {
        status: statusFilter
    } : {}), femaleFilter.trim() ? {
        female: femaleFilter.trim()
    } : {}), createdFrom ? {
        created_from: createdFrom
    } : {}), createdTo ? {
        created_to: createdTo
    } : {}), [page, perPage, statusFilter, femaleFilter, createdFrom, createdTo]);
    const listQueryKey = [...DATE_POST_QUERY_KEY, apiFilters];
    const _useQuery = useQuery({
        queryKey: listQueryKey,
        queryFn: () => fetchAdminDatePosts(apiFilters),
        keepPreviousData: true
    }), data = _useQuery.data, isLoading = _useQuery.isLoading, isFetching = _useQuery.isFetching, refetch = _useQuery.refetch;
    const _useQuery2 = useQuery({
        queryKey: [...DATE_POST_QUERY_KEY, 'detail', selectedId],
        queryFn: () => fetchAdminDatePost(selectedId),
        enabled: detailOpen && selectedId != null,
        staleTime: 0,
        refetchOnMount: 'always'
    }), detailData = _useQuery2.data, detailLoading = _useQuery2.isLoading, detailFetching = _useQuery2.isFetching;
    const detail = detailData === null || detailData === void 0 ? void 0 : detailData.data;
    const detailBusy = detailLoading || detailFetching;
    useEffect(() => {
        if (initialPostId == null)
            return;
        setSelectedId(initialPostId);
        setDetailOpen(true);
    }, [initialPostId]);
    const invalidateList = () => __awaiter(this, void 0, void 0, function* () {
        yield queryClient.invalidateQueries({
            queryKey: DATE_POST_QUERY_KEY
        });
    });
    const pauseMutation = useMutation({
        mutationFn: id => pauseAdminDatePost(id),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            if (!response.success) {
                throw new Error(response.error || 'Pause failed');
            }
            yield invalidateList();
            messageApi.success(response.message || '休止しました');
        }),
        onError: error => {
            messageApi.error(error.message);
        }
    });
    const resumeMutation = useMutation({
        mutationFn: id => resumeAdminDatePost(id),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            if (!response.success) {
                throw new Error(response.error || 'Resume failed');
            }
            yield invalidateList();
            messageApi.success(response.message || '再開しました');
        }),
        onError: error => {
            messageApi.error(error.message);
        }
    });
    const deleteMutation = useMutation({
        mutationFn: id => deleteAdminDatePost(id),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            if (!response.success) {
                throw new Error(response.error || 'Delete failed');
            }
            yield invalidateList();
            messageApi.success(response.message || '削除しました');
            setDetailOpen(false);
            setSelectedId(null);
        }),
        onError: error => {
            messageApi.error(error.message);
        }
    });
    const openDetail = record => {
        queryClient.removeQueries({
            queryKey: [...DATE_POST_QUERY_KEY, 'detail', record.id]
        });
        setSelectedId(record.id);
        setDetailOpen(true);
    };
    const closeDetail = () => {
        setDetailOpen(false);
        setSelectedId(null);
    };
    const handleFilter = values => {
        var _a, _b, _c, _d, _e;
        setStatusFilter(values.status || 'all');
        setFemaleFilter(((_a = values.female) === null || _a === void 0 ? void 0 : _a.trim()) || '');
        setCreatedFrom((_c = (_b = values.created_range) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.format('YYYY-MM-DD'));
        setCreatedTo((_e = (_d = values.created_range) === null || _d === void 0 ? void 0 : _d[1]) === null || _e === void 0 ? void 0 : _e.format('YYYY-MM-DD'));
        setPage(1);
    };
    const handleResetFilter = () => {
        filterForm.resetFields();
        setStatusFilter('all');
        setFemaleFilter('');
        setCreatedFrom(undefined);
        setCreatedTo(undefined);
        setPage(1);
    };
    const handleTableChange = pagination => {
        var _a, _b;
        setPage((_a = pagination.current) !== null && _a !== void 0 ? _a : 1);
        setPerPage((_b = pagination.pageSize) !== null && _b !== void 0 ? _b : 20);
    };
    const confirmDelete = id => {
        Modal.confirm({
            title: 'この募集を削除しますか？',
            okText: '削除',
            okType: 'danger',
            cancelText: 'キャンセル',
            onOk: () => deleteMutation.mutateAsync(id)
        });
    };
    const actionBusy = pauseMutation.isPending || resumeMutation.isPending || deleteMutation.isPending;
    const columns = [{
            title: 'ID',
            dataIndex: 'id',
            width: 72
        }, {
            title: '女性',
            width: 180,
            render: (_, record) => /*#__PURE__*/ React.createElement("div", {
                className: "flex flex-col gap-1 text-[12px]"
            }, /*#__PURE__*/ React.createElement("span", null, record.female_name || '-'), /*#__PURE__*/ React.createElement(Link, {
                href: `/userpage?id=${record.female_user_id}`,
                target: "_blank"
            }, "ID ", record.female_user_id))
        }, {
            title: '会いたい日時',
            dataIndex: 'meet_at_text',
            width: 140,
            render: value => truncateText(value, 24)
        }, {
            title: '会いたい場所',
            dataIndex: 'place_text',
            width: 120,
            render: value => truncateText(value, 24)
        }, {
            title: 'したいこと',
            dataIndex: 'activity_text',
            width: 160,
            render: value => truncateText(value)
        }, {
            title: '求める条件',
            dataIndex: 'condition_text',
            width: 160,
            render: value => truncateText(value)
        }, {
            title: '状態',
            dataIndex: 'status',
            width: 100,
            render: (status, record) => /*#__PURE__*/ React.createElement(Tag, {
                color: DATE_POST_STATUS_COLOR_MAP[status] || 'default'
            }, record.status_label || DATE_POST_STATUS_LABEL_MAP[status] || status)
        }, {
            title: '応募数',
            dataIndex: 'applications_count',
            width: 72
        }, {
            title: '作成日時',
            dataIndex: 'created_at',
            width: 140,
            render: value => formatDatetime(value)
        }, {
            title: '掲載期限',
            dataIndex: 'expires_at',
            width: 140,
            render: value => formatDatetime(value)
        }, {
            title: '操作',
            width: 220,
            fixed: 'right',
            render: (_, record) => /*#__PURE__*/ React.createElement(Space, {
                size: 4,
                wrap: true
            }, /*#__PURE__*/ React.createElement(Button, {
                type: "link",
                size: "small",
                onClick: () => openDetail(record)
            }, "\u8A73\u7D30"), record.can_pause ? /*#__PURE__*/ React.createElement(Button, {
                size: "small",
                disabled: actionBusy,
                onClick: () => pauseMutation.mutate(record.id)
            }, "\u4F11\u6B62") : null, record.can_resume ? /*#__PURE__*/ React.createElement(Button, {
                size: "small",
                disabled: actionBusy,
                onClick: () => resumeMutation.mutate(record.id)
            }, "\u518D\u958B") : null, record.can_delete ? /*#__PURE__*/ React.createElement(Button, {
                size: "small",
                danger: true,
                disabled: actionBusy,
                onClick: () => confirmDelete(record.id)
            }, "\u524A\u9664") : null)
        }];
    const applicationColumns = [{
            title: '男性',
            width: 160,
            render: (_, row) => /*#__PURE__*/ React.createElement("div", {
                className: "flex flex-col gap-1 text-[12px]"
            }, /*#__PURE__*/ React.createElement("span", null, row.male_name || '-'), /*#__PURE__*/ React.createElement(Link, {
                href: `/userpage?id=${row.male_user_id}`,
                target: "_blank"
            }, "ID ", row.male_user_id))
        }, {
            title: '年齢',
            width: 72,
            render: (_, row) => row.male_age || '-'
        }, {
            title: 'アピールポイント',
            dataIndex: 'appeal_text',
            render: value => /*#__PURE__*/ React.createElement("span", {
                className: "whitespace-pre-wrap text-[12px]"
            }, value || '-')
        }, {
            title: '応募日時',
            dataIndex: 'created_at',
            width: 140,
            render: value => formatDatetime(value)
        }, {
            title: '消費いいね',
            dataIndex: 'likes_consumed',
            width: 90
        }, {
            title: '状態',
            dataIndex: 'status_label',
            width: 110,
            render: (value, row) => /*#__PURE__*/ React.createElement(Tag, {
                color: row.matched ? 'green' : 'blue'
            }, value)
        }];
    return /*#__PURE__*/ React.createElement("div", {
        className: embedded ? '' : 'min-h-screen bg-[#f5f5f5] px-6 py-6'
    }, contextHolder, /*#__PURE__*/ React.createElement("div", {
        className: embedded ? '' : 'mx-auto max-w-[1680px]'
    }, !embedded && /*#__PURE__*/ React.createElement("div", {
        className: "mb-4 text-[24px] font-semibold text-[#111827]"
    }, "\u51FA\u4F1A\u3044\u305F\u3044\u7BA1\u7406"), /*#__PURE__*/ React.createElement(Card, {
        className: "mb-4"
    }, /*#__PURE__*/ React.createElement(Form, {
        form: filterForm,
        layout: "inline",
        initialValues: {
            status: 'all'
        },
        onFinish: handleFilter,
        className: "flex flex-wrap gap-y-3"
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        name: "status",
        label: "\u72B6\u614B"
    }, /*#__PURE__*/ React.createElement(Select, {
        style: {
            width: 140
        },
        options: DATE_POST_STATUS_FILTER_OPTIONS
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        name: "female",
        label: "\u5973\u6027"
    }, /*#__PURE__*/ React.createElement(Input, {
        placeholder: "\u5973\u6027ID\u307E\u305F\u306F\u30E1\u30FC\u30EB",
        style: {
            width: 200
        },
        allowClear: true
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        name: "created_range",
        label: "\u4F5C\u6210\u65E5"
    }, /*#__PURE__*/ React.createElement(RangePicker, {
        allowEmpty: [true, true]
    })), /*#__PURE__*/ React.createElement(Form.Item, null, /*#__PURE__*/ React.createElement(Space, null, /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        htmlType: "submit"
    }, "\u7D5E\u308A\u8FBC\u3080"), /*#__PURE__*/ React.createElement(Button, {
        onClick: handleResetFilter
    }, "\u30EA\u30BB\u30C3\u30C8"), /*#__PURE__*/ React.createElement(Button, {
        onClick: () => refetch()
    }, "\u66F4\u65B0"))))), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Table, {
        rowKey: "id",
        loading: isLoading || isFetching,
        columns: columns,
        dataSource: (_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : [],
        scroll: {
            x: 1400
        },
        pagination: {
            // Prefer local page/perPage so current stays stable while keepPreviousData
            // still shows the previous rows (meta.current_page would lag on the old page).
            current: page,
            pageSize: perPage,
            total: (_c = (_b = data === null || data === void 0 ? void 0 : data.meta) === null || _b === void 0 ? void 0 : _b.total_count) !== null && _c !== void 0 ? _c : 0,
            showSizeChanger: true
        },
        onChange: handleTableChange
    }))), /*#__PURE__*/ React.createElement(Drawer, {
        title: `募集 #${selectedId !== null && selectedId !== void 0 ? selectedId : ''}`,
        width: 820,
        open: detailOpen,
        onClose: closeDetail,
        destroyOnClose: true,
        extra: detail ? /*#__PURE__*/ React.createElement(Space, null, detail.can_pause ? /*#__PURE__*/ React.createElement(Button, {
            disabled: actionBusy,
            onClick: () => pauseMutation.mutate(detail.id)
        }, "\u4F11\u6B62") : null, detail.can_resume ? /*#__PURE__*/ React.createElement(Button, {
            disabled: actionBusy,
            onClick: () => resumeMutation.mutate(detail.id)
        }, "\u518D\u958B") : null, detail.can_delete ? /*#__PURE__*/ React.createElement(Button, {
            danger: true,
            disabled: actionBusy,
            onClick: () => confirmDelete(detail.id)
        }, "\u524A\u9664") : null) : null
    }, detailBusy && !detail ? /*#__PURE__*/ React.createElement("div", null, "Loading...") : detail ? /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col gap-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-2 gap-3 text-[13px]"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u72B6\u614B"), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Tag, {
        color: DATE_POST_STATUS_COLOR_MAP[detail.status]
    }, detail.status_label))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u5973\u6027"), /*#__PURE__*/ React.createElement("div", null, detail.female_name || '-', " /", ' ', /*#__PURE__*/ React.createElement(Link, {
        href: `/userpage?id=${detail.female_user_id}`,
        target: "_blank"
    }, "ID ", detail.female_user_id)), /*#__PURE__*/ React.createElement("div", null, detail.female_email || '-')), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u4F1A\u3044\u305F\u3044\u65E5\u6642"), /*#__PURE__*/ React.createElement("div", null, detail.meet_at_text || '-')), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u4F1A\u3044\u305F\u3044\u5834\u6240"), /*#__PURE__*/ React.createElement("div", null, detail.place_text || '-')), /*#__PURE__*/ React.createElement("div", {
        className: "col-span-2"
    }, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u3057\u305F\u3044\u3053\u3068"), /*#__PURE__*/ React.createElement("div", {
        className: "whitespace-pre-wrap"
    }, detail.activity_text || '-')), /*#__PURE__*/ React.createElement("div", {
        className: "col-span-2"
    }, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u6C42\u3081\u308B\u6761\u4EF6"), /*#__PURE__*/ React.createElement("div", {
        className: "whitespace-pre-wrap"
    }, detail.condition_text || '-')), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u4F5C\u6210\u65E5\u6642"), /*#__PURE__*/ React.createElement("div", null, formatDatetime(detail.created_at))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u63B2\u8F09\u671F\u9650"), /*#__PURE__*/ React.createElement("div", null, formatDatetime(detail.expires_at))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u6B21\u306B\u52DF\u96C6\u3067\u304D\u308B\u6642\u523B"), /*#__PURE__*/ React.createElement("div", null, detail.next_post_at ? formatDatetime(detail.next_post_at) : '今すぐ'))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        strong: true
    }, "\u5FDC\u52DF\u8005"), /*#__PURE__*/ React.createElement(Table, {
        className: "mt-3",
        rowKey: "id",
        size: "small",
        columns: applicationColumns,
        dataSource: (_d = detail.applications) !== null && _d !== void 0 ? _d : [],
        pagination: false,
        locale: {
            emptyText: '応募者はいません'
        }
    }))) : /*#__PURE__*/ React.createElement(Text, {
        type: "secondary"
    }, "\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093")));
}
